import React, { useState } from "react";
import { EditOutlined, MoreOutlined, ReadOutlined } from "@ant-design/icons";
import { Dropdown, Image, Popconfirm, Menu, Modal, Input } from "antd";
import { useMutation } from "react-query";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Loading } from "../..";
import del from "../../../assets/svg/del.png";
import { isEmpty, Toast, truncate } from "../../../lib/helpers/helpers";
import { btnStyle, inputStyle } from "../../../lib/styles/styleLibrary";
import errorHandler from "../../../redux/actions/errorHandler";
import { deleteNote, editNote } from "../../../redux/actions/notes";

const Wrapper = styled.div`
	${tw`bg-white box-border`}
	min-width: 16rem;
	width: 18rem !important;
	height: fit-content;
	background: #ffffff;
	box-shadow: 0px 9px 30px rgba(32, 56, 85, 0.1);
	border-radius: 10px;

	.ant-btn .ant-btn-primary .ant-btn-sm {
		${tw`shadow-sm!`}
		border-radius: 8px !important;
	}
`;

const NoteComponent = (props) => {
	const { cardTitle, children, date, data, refetch } = props;
	// console.log(data);
	const { TextArea } = Input;
	const [isVisible, setIsVisible] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [fields, setFields] = useState({
		noteId: data.id,
		title: cardTitle,
		description: children,
	});
	const { mutateAsync: delNote, isLoading: delloading } =
		useMutation(deleteNote);

	const handleDelete = async () => {
		try {
			const response = await delNote(data.id);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				console.log(response);
				const { title, message } = response.data.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${response.data.data}`,
				});
				setTimeout(() => {
					refetch();
				}, 750);
			}
		} catch (err) {
			return errorHandler(err);
		}
	};
	const { mutateAsync: handleEdit, isLoading: enloading } =
		useMutation(editNote);

	const handeEditNote = async (e) => {
		e.preventDefault();
		if (isEmpty(fields.title) || isEmpty(fields.description)) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		try {
			const response = await handleEdit(fields);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				const { title, message } = response.data.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `Note updated successfully`,
				});
				setTimeout(() => {
					refetch();
					setIsEdit(false);
				}, 750);
			}
		} catch (err) {
			console.log(err);
			return false;
		}
	};

	const menu = (
		<Menu>
			<Menu.Item>
				<ReadOutlined onClick={() => setIsVisible(true)} />
			</Menu.Item>
			<Menu.Item>
				{" "}
				<EditOutlined onClick={() => setIsEdit(true)} />
			</Menu.Item>
		</Menu>
	);

	return (
		<Wrapper>
			<Loading loading={data.id && delloading}>
				<div tw="p-5">
					<div tw="flex flex-row flex-nowrap justify-between items-center">
						<h5 tw="text-sm font-bold leading-snug tracking-wider truncate">
							{cardTitle}
						</h5>
						<Dropdown overlay={menu} trigger="click">
							<MoreOutlined tw="pl-4" />
						</Dropdown>
					</div>

					<div>
						<p tw="mt-8 mb-8 text-xs text-justify opacity-70 whitespace-pre-wrap">
							{truncate(children, 120)}
						</p>
						<hr tw="w-full opacity-20 mb-4" />
						<div tw="relative">
							<div tw="text-center font-semibold opacity-50 text-xs">
								{date}
							</div>
							<span tw="absolute right-0 -bottom-1 cursor-pointer">
								<Popconfirm
									placement="top"
									title={"Are you sure to delete this note?"}
									onConfirm={handleDelete}
									okText="Yes"
									cancelText="No">
									<Image
										preview={false}
										src={del}
										alt=""
										width={12}
										height={12}
									/>
								</Popconfirm>
							</span>
						</div>
					</div>
				</div>
			</Loading>
			<Modal
				visible={isVisible}
				onCancel={() => setIsVisible(!isVisible)}
				footer={[
					<button
						css={btnStyle}
						key="Close"
						onClick={() => setIsVisible(!isVisible)}>
						Back
					</button>,
				]}>
				<div tw="">
					<div tw="flex flex-row flex-nowrap justify-between items-center">
						<h5 tw="text-sm font-bold leading-snug tracking-wider truncate">
							{cardTitle}
						</h5>
					</div>

					<div>
						<p tw="mt-8 mb-8 text-xs text-justify whitespace-pre-wrap opacity-70">
							{children}
						</p>

						<div tw="relative">
							<div tw="text-center font-semibold opacity-50 text-xs">
								{date}
							</div>
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				visible={isEdit}
				closable={false}
				footer={[
					<div tw="mt-4 mb-4 flex flex-row gap-4">
						<button
							css={btnStyle}
							tw="rounded-md bg-transparent border-appPink text-appPink font-normal text-sm hover:(bg-gray-50)"
							// disabled={enloading}
							onClick={() => setIsEdit(false)}>
							Cancel
						</button>
						<button
							css={btnStyle}
							tw="rounded-md"
							disabled={enloading}
							onClick={(e) => handeEditNote(e)}>
							{enloading ? <Loading /> : "Edit"}
						</button>
					</div>,
				]}>
				<h3
					tw="font-semibold tracking-wider"
					style={{ fontSize: "15px" }}>
					Edit <b tw="uppercase text-appPink">{cardTitle}?</b>
				</h3>

				<div tw="mt-4">
					<Input
						placeholder="Title"
						type="text"
						css={inputStyle}
						disabled={enloading}
						value={fields.title}
						onChange={(e) =>
							setFields({ ...fields, title: e.target.value })
						}
						tw="w-full text-xs! px-3 py-6 rounded-md"
					/>
				</div>

				<div tw="h-4/5">
					<TextArea
						placeholder="Write body here?"
						autoSize={{ minRows: 10 }}
						disabled={enloading}
						value={fields.description}
						onChange={(e) =>
							setFields({
								...fields,
								description: e.target.value,
							})
						}
						tw="mb-4 text-xs! h-full! p-4 rounded! box-border"
						css={inputStyle}
					/>
				</div>
			</Modal>
		</Wrapper>
	);
};

export default NoteComponent;
